<template>
    <b-col cols="5" :class="(field.sections.includes(getSelectedSection.name) && field.programs.includes(getSelectedProgram(scenarioName)) || field.name === 'Program') ? 'border-right' : '' ">
        <!-- Add encompass values for every field in the section -->
        <div v-if="field.sections.includes(getSelectedSection.name) && field.programs.includes(getSelectedProgram(scenarioName)) || field.name === 'Program'">
        <b-form-group
            label-align="left"
            v-for="encompassVal in field.encompassValues"
            :key="encompassVal.id"
        >
            <slot name="label">
                {{encompassVal.name}} 
                <el-popover trigger="hover" placement="top" :content="encompassVal.id" width="auto" popper-class="id-popover">
                    <i class="fas fa-info-circle fa-sm text-ao-light" slot="reference"></i>
                </el-popover>
            </slot>
            <b-form-input disabled :value="encompassVal.value" class="mt-2" :data-test="`encompass-input-${encompassVal.name}`"></b-form-input>
        </b-form-group>
        

        <!-- If no encompass value exists for a field create a gap -->
        <b-form-group label-align="left" v-if="field.encompassValues.length === 0">
            <slot name="label">
                {{field.name}}
                <el-popover trigger="hover" placement="top" content="No Encompass ID" popper-class="id-popover">
                    <i class="fas fa-question-circle fa-sm text-ao-light" slot="reference"></i>
                </el-popover>
            </slot>
            <b-input hidden :data-test="`encompass-input-${field.name}`"></b-input>
        </b-form-group>
        </div>
    </b-col>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        field: Object,
        scenarioName: String
    },
    computed: {
        ...mapGetters(["getSelectedSection", "getSelectedProgram"]),
    },
};
</script>

<style>
.id-popover {
    padding: 8px;
}
</style>